/**
 * @file MessagesRedirect.tsx
 * @description Старый адрес `/shop/:slug/messages` (phase10.7) — страницы
 * «Сообщения» больше нет, переписка живёт в окне с кнопкой в углу (SC64,
 * chat-window-design.md §6). Адрес ведёт на главную магазина с открытым
 * окном (`?chat=open`); без права переписки окно покажет «Нет доступа к
 * переписке с клиентами».
 */

import { Navigate } from "react-router";

import { CHAT_OPEN_VALUE, CHAT_PARAM } from "../../../components/chat/useChatUrlParam";

export function MessagesRedirect() {
  return <Navigate to={{ pathname: "..", search: `?${CHAT_PARAM}=${CHAT_OPEN_VALUE}` }} relative="path" replace />;
}
